module.exports = __webpack_public_path__ + "img/1_OG.df9aa665.png";